import { useState } from 'react';
import { Banner, BlockStack, Button, Modal, Text } from '@shopify/polaris';
import agent from '../../app/api/agent';
import { formatLocalDateTime } from './utils/dateTime';

export interface PilotOperatorAudit {
  sessions: { id: string; operatorEmail: string; createdUtc: string; expiresUtc: string; revokedUtc?: string }[];
  requests: { id: string; operatorEmail: string; operation: string; state: string; createdUtc: string }[];
}
export default function PilotOperatorTools({ token, sourceId, active, domain, native = false, showAudit = true }: { token: string; sourceId: number; active: boolean; domain?: string; native?: boolean; showAudit?: boolean }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [audit, setAudit] = useState<PilotOperatorAudit | null>(null);
  const open = async () => {
    const tab = window.open('about:blank', '_blank');
    if (!tab) { setError('Allow a new tab to open the operator session.'); return; }
    tab.opener = null;
    setBusy(true); setError('');
    try {
      const result = await agent.Admin.startPilotImpersonation(token, sourceId, native);
      if (!/^\/operator-access\/handoff#code=[A-F0-9]{64}$/.test(result.handoffUrl)) throw new Error('Invalid handoff');
      tab.location.replace(result.handoffUrl);
    } catch {
      tab.close(); setError('Unable to open operator access. Reload store status; the store must still be active on PFV2.');
    } finally { setBusy(false); }
  };
  return <BlockStack gap="200">
    {active && <Button variant="plain" loading={busy} onClick={() => void open()}>{native ? 'Impersonate merchant' : 'Impersonate pilot admin'}</Button>}
    {showAudit && <Button variant="plain" onClick={() => {
      setError(''); void agent.Admin.pilotImpersonationAudit(token, sourceId, native).then(setAudit).catch(() => setError('Unable to load operator audit.'));
    }}>Operator audit</Button>}
    {error && <Text as="p" tone="critical">{error}</Text>}
    <Modal open={audit != null} onClose={() => setAudit(null)} title={`Operator access · ${domain || sourceId}`}>
      <Modal.Section><BlockStack gap="300">
        <Banner>Latest 50 sessions and 100 requests. Operator edits affect the live store.</Banner>
        {audit?.sessions.map(s => <Text as="p" key={s.id}>{s.operatorEmail} · {formatLocalDateTime(s.createdUtc)} · {s.revokedUtc ? 'Ended' : Date.parse(s.expiresUtc) <= Date.now() ? 'Expired' : 'Active'} · Expires {formatLocalDateTime(s.expiresUtc)}</Text>)}
        {audit?.sessions.length === 0 && <Text as="p">No operator sessions recorded.</Text>}
        {audit?.requests.map(r => <Text as="p" key={r.id}>{formatLocalDateTime(r.createdUtc)} · {r.operatorEmail} · {r.operation} · {r.state}</Text>)}
      </BlockStack></Modal.Section>
    </Modal>
  </BlockStack>;
}
